export default "__VITE_ASSET__C1wGO7bV__"